import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';
import OwnerTrust from './OwnerTrust';
import OwnerBusiness from './OwnerBusiness';
import OwnerBOLM from './OwnerBOLM';
import OwnerRAL from './OwnerRAL';
import OwnerStateLand from './OwnerStateLand';

export default class AddOwner {
    id: number;
    ownerType: number;
    individualOwner: OwnerIndividual;
    ownerTrust: OwnerTrust;
    businessOwner: OwnerBusiness;
    bolmOwner: OwnerBOLM;
    ralOwner: OwnerRAL;
    stateLandOwner: OwnerStateLand;
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/add_ownership_revised/AddOwner.ts